import { render, staticRenderFns } from "./RulesEdit.vue?vue&type=template&id=3f5967be&"
import script from "./RulesEdit.vue?vue&type=script&lang=js&"
export * from "./RulesEdit.vue?vue&type=script&lang=js&"
import style0 from "./RulesEdit.vue?vue&type=style&index=0&id=3f5967be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports